export default __webpack_public_path__ + "static/media/380.876bbb6e.png";